module.exports = __webpack_public_path__ + "static/media/Polygon.b5e52ead.svg";